<template>
</template>

<script>
import axios from 'axios';

export default {
    name: 'LogoutView',

    mounted() {
        this.logout()
    },

    methods: {
        async apiLogout() {
            try {
                await axios.post("/api/v1/token/logout/")
                console.log('Successfully logged out')
            } catch (error) {
                console.log(error)
            }
        },

        async logout() {
            if (this.$store.state.isAuthenticated) {
                await this.apiLogout()
            }

            delete axios.defaults.headers.common['Authorization']

            this.$store.dispatch('logout')

            this.$router.push('/login')
        }
    }
}
</script>